import '../../assets/index35.css';var H = Object.defineProperty, R = Object.defineProperties;
var $ = Object.getOwnPropertyDescriptors;
var I = Object.getOwnPropertySymbols;
var F = Object.prototype.hasOwnProperty, M = Object.prototype.propertyIsEnumerable;
var B = (i, t, e) => t in i ? H(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e, v = (i, t) => {
  for (var e in t || (t = {}))
    F.call(t, e) && B(i, e, t[e]);
  if (I)
    for (var e of I(t))
      M.call(t, e) && B(i, e, t[e]);
  return i;
}, C = (i, t) => R(i, $(t));
var E = (i, t) => {
  var e = {};
  for (var r in i)
    F.call(i, r) && t.indexOf(r) < 0 && (e[r] = i[r]);
  if (i != null && I)
    for (var r of I(i))
      t.indexOf(r) < 0 && M.call(i, r) && (e[r] = i[r]);
  return e;
};
import { jsx as o, jsxs as G } from "react/jsx-runtime";
import { forwardRef as K } from "react";
import { Select as V } from "../Select/index.js";
import { ClockFarFAIcon as W } from "../Icons/index.js";
import { Label as L } from "../Label/index.js";
import { G as Y } from "../../Group-CbE78j-X.js";
import { f as q, u as D, c as J } from "../../factory-ueRxoNOV.js";
import { u as O } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { I as j } from "../../InputBase-Cabx1d9o.js";
var Q = { input: "m_468e7eda" };
const U = {}, N = q((i, t) => {
  const e = D("TimeInput", U, i), A = e, {
    classNames: r,
    styles: b,
    unstyled: k,
    vars: x,
    withSeconds: _,
    minTime: l,
    maxTime: m,
    value: y,
    onChange: c,
    step: T
  } = A, g = E(A, [
    "classNames",
    "styles",
    "unstyled",
    "vars",
    "withSeconds",
    "minTime",
    "maxTime",
    "value",
    "onChange",
    "step"
  ]), { resolvedClassNames: f, resolvedStyles: h } = O({
    classNames: r,
    styles: b,
    props: e
  }), n = (u) => {
    if (l !== void 0 || m !== void 0) {
      const [a, p, S] = u.split(":").map(Number);
      if (l) {
        const [s, d, z] = l.split(":").map(Number);
        if (a < s || a === s && p < d || _ && a === s && p === d && S < z)
          return -1;
      }
      if (m) {
        const [s, d, z] = m.split(":").map(Number);
        if (a > s || a === s && p > d || _ && a === s && p === d && S > z)
          return 1;
      }
    }
    return 0;
  }, w = (u) => {
    var a, p, S;
    if ((a = e.onBlur) == null || a.call(e, u), l !== void 0 || m !== void 0) {
      const s = u.currentTarget.value;
      if (s) {
        const d = n(s);
        d === 1 ? (u.currentTarget.value = m, (p = e.onChange) == null || p.call(e, u)) : d === -1 && (u.currentTarget.value = l, (S = e.onChange) == null || S.call(e, u));
      }
    }
  };
  return /* @__PURE__ */ o(
    j,
    C(v({
      classNames: C(v({}, f), { input: J(Q.input, f == null ? void 0 : f.input) }),
      styles: h,
      unstyled: k,
      ref: t,
      value: y,
      step: T != null ? T : _ ? 1 : 60
    }, g), {
      onChange: c,
      onBlur: w,
      type: "time",
      __staticSelector: "TimeInput"
    })
  );
});
N.classes = j.classes;
N.displayName = "@mantine/dates/TimeInput";
const X = "TimePicker-module__TimePicker___o-VIb", Z = "TimePicker-module__label___LAFEv", ee = "TimePicker-module__root___KTIF0", ie = "TimePicker-module__input___CGu2t", te = "TimePicker-module__error___viWYf", re = "TimePicker-module__description___6g0SA", se = "TimePicker-module__timezoneSelect___CP18s", P = {
  TimePicker: X,
  label: Z,
  root: ee,
  input: ie,
  error: te,
  description: re,
  timezoneSelect: se
}, ae = K((i, t) => {
  const h = i, {
    "data-plum-id": e,
    leftSection: r = /* @__PURE__ */ o(W, { size: 14 }),
    size: b = "sm",
    label: k,
    description: x,
    error: _,
    variant: l = "regular",
    value: m,
    timezone: y = "EST",
    onChange: c,
    onTimezoneChange: T
  } = h, g = E(h, [
    "data-plum-id",
    "leftSection",
    "size",
    "label",
    "description",
    "error",
    "variant",
    "value",
    "timezone",
    "onChange",
    "onTimezoneChange"
  ]), f = [
    { value: "EST", label: "EST" },
    { value: "CST", label: "CST" },
    { value: "MST", label: "MST" },
    { value: "PST", label: "PST" }
    // Add more timezones as needed
  ];
  return /* @__PURE__ */ G("div", { className: P.TimePicker, "data-time-variant": l, ref: t, children: [
    l === "timezone" ? /* @__PURE__ */ G(Y, { gap: 0, align: "flex-end", children: [
      /* @__PURE__ */ o(
        N,
        v({
          classNames: P,
          "data-plum-id": e,
          leftSection: r,
          size: b,
          label: /* @__PURE__ */ o(L, { label: k }),
          error: _,
          value: m,
          onChange: (n) => c == null ? void 0 : c(n.currentTarget.value)
        }, g)
      ),
      /* @__PURE__ */ o("div", { className: P.timezoneSelect, children: /* @__PURE__ */ o(
        V,
        {
          data: f,
          value: y,
          onChange: (n) => n && (T == null ? void 0 : T(n)),
          label: " "
        }
      ) })
    ] }) : /* @__PURE__ */ o(
      N,
      v({
        classNames: P,
        "data-plum-id": e,
        leftSection: r,
        size: b,
        label: /* @__PURE__ */ o(L, { label: k }),
        error: _,
        value: m,
        onChange: (n) => c == null ? void 0 : c(n.currentTarget.value)
      }, g)
    ),
    x && !_ && /* @__PURE__ */ o("div", { className: P.description, children: x })
  ] });
});
ae.displayName = "TimePicker";
export {
  ae as TimePicker
};
